import FileOverviewListApp from "file/List/App";
import {
  type RouteObject,
} from "react-router";
import SystemWideFilesApp from "systemwidefiles/app";

declare let viewModel: any;

export const fileRoute: RouteObject = {
  path: "file",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: FileOverviewListApp,
  }, {
    path: "systemwide",
    loader: () => viewModel,
    Component: SystemWideFilesApp,
  }]
};